import MasterTable from './MasterTable'

/* ข้อมูลหลัก → สาขา · backend: src/routes/adminBranches.js

   ⚠️ คีย์คือ BranchCode และ **แก้ไม่ได้** หลังสร้างแล้ว — เป็นรหัสที่ตารางอื่น
      อ้างอยู่โดยไม่มี FK คอยตาม (เหตุผลเต็มอยู่หัวไฟล์ route)
   คอลัมน์ inactive มาจาก sql/mssql/012_branch_inactive.sql */

type Branch = {
  BranchCode: string
  BranchName: string
  CompanyCode: string
  inactive: boolean
  staffCount: number
}

export default function Branches() {
  return (
    <MasterTable<Branch>
      title="สาขา"
      unit="สาขา"
      companyScoped
      addLabel="เพิ่มสาขา"
      base="/api/admin/branches"
      keyOf={(r) => r.BranchCode}
      labelOf={(r) => `${r.BranchCode} ${r.BranchName}`}
      isInactive={(r) => r.inactive}
      cols={[
        { label: 'รหัส', cell: (r) => r.BranchCode, sortKey: 'code' },
        { label: 'ชื่อสาขา', cell: (r) => r.BranchName, sortKey: 'name' },
        { label: 'พนักงาน', cell: (r) => r.staffCount, num: true, sortKey: 'staff' },
      ]}
      fields={[
        /* ย้ายสาขาข้ามบริษัทไม่ได้หลังสร้าง — Users ผูกด้วย (BranchCode, CompanyCode) คู่กัน */
        { name: 'companyCode', label: 'บริษัท', required: true, lockOnEdit: true, source: 'companies' },
        { name: 'branchCode', label: 'รหัสสาขา', maxLength: 20, required: true, lockOnEdit: true },
        { name: 'branchName', label: 'ชื่อสาขา', maxLength: 100, required: true },
      ]}
      toDraft={(r) => ({
        companyCode: r.CompanyCode,
        branchCode: r.BranchCode,
        branchName: r.BranchName,
      })}
    />
  )
}
